// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getAuditStatus} from '../../shared/repositories';

export const readAuditStatus = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getAuditStatus();

            const hasNoResult = (data.divisionSummary === null);

            hasNoResult ?
                dispatch({
                    hasNoResult,
                    type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
                }) :
                dispatch({
                    data,
                    type: actions.UPDATE_AUDIT_STATUS_REPORT
                });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/audit-status/action-creators/get-audit-status.js